const StrategyModal = ({ strategy, onClose }) => {
  const strategyType = (strategy.strategy_type || '').toUpperCase();
  const isDemo = strategyType === 'DEMO';
  const isBacktests = strategyType === 'BACKTESTS';
  const isHistory = strategyType === 'HISTORY';

  const monthly_roi = (parseFloat(strategy.annual_roi) / 12).toFixed(2) + '%' || '—';

const modalClass = `modal ${isDemo ? 'modal--demo' : isBacktests ? 'modal--backtests' : isHistory ? 'modal--history' : ''}`;
const modalIconClass = `modalIcon ${isDemo ? 'modalIcon--demo' : isBacktests ? 'modalIcon--backtests' : isHistory ? 'modalIcon--history' : ''}`;
const modalStrategyClass = `modalStrategy ${isDemo ? 'modalStrategy--demo' : isBacktests ? 'modalStrategy--backtests' : isHistory ? 'modalStrategy--history' : ''}`;

  if (!strategy || typeof strategy.symbol !== 'string') return null;
    return (
    <div className="modalOverlay">
      <div className={modalClass}>
        <div className="modalHeader">
          {strategy._logoUrl && <img src={strategy._logoUrl} alt="logo" className={modalIconClass} />}
          <div>
            <div className="modalSymbol">{strategy.symbol || 'Brak symbolu'}</div>
            <div className={modalStrategyClass}>STRATEGY MULTILEVEL</div>
          </div>
        </div>

        <div className="modalContent">
          <p><strong>Current Market Price:</strong> {strategy.current_market_price || '—'}</p>
          <p><strong>Avg Price:</strong> {strategy.avg_price || '—'}</p>
          <p><strong>Open Price:</strong> {strategy.open_price || '—'}</p>
          <p><strong>Drop Avg to Open:</strong> {strategy.drop_avg_to_open || '—'}</p>
          <p><strong>Drop Market to Avg:</strong> {strategy.drop_market_to_avg || '—'}</p>
          <p><strong>Max Price Drop:</strong> {strategy.max_price_drop || '—'}</p>
          <p><strong>Last Trades:</strong> {strategy.last_trades || '—'}</p>
          <p><strong>Monthly ROI:</strong> {monthly_roi}</p>
          <p><strong>Annual ROI:</strong> {strategy.annual_roi || '—'}</p>
          <p><strong>Drawdown:</strong> {strategy.drawdown || '—'}</p>
          <p><strong>Total Qty:</strong> {strategy.total_open_quantity || '—'}</p>
          <p><strong>Realized PnL:</strong> {strategy.pnl_realized ?? '—'}</p>
          <p><strong>Unrealized PnL:</strong> {strategy.pnl_unrealized ?? '—'}</p>
          <p><strong>Total PnL:</strong> {strategy.pnl_total ?? '—'}</p>
          <p><strong>Runtime closed:</strong> {strategy.runtime || '—'}</p>
        </div>

        <button onClick={onClose} className="closeButton">Zamknij</button>
      </div>
    </div>
  );
};

export default StrategyModal;
